import type { Lang } from "./types";

export function resolveStorefrontLanguage(input: {
  defaultLocale?: string | undefined;
  enabledLocales?: readonly string[] | undefined;
  storedLocale?: string | null | undefined;
}): Lang {
  if (
    (input.storedLocale === "ar" || input.storedLocale === "en") &&
    input.enabledLocales?.includes(input.storedLocale)
  ) {
    return input.storedLocale;
  }
  return input.defaultLocale === "en" && input.enabledLocales?.includes("en") ? "en" : "ar";
}
